import { getConfig } from '../../config'
import { navHelper } from '../services/navigation'
import { UserService } from '../services/user'
import { QueryParams } from './url'

const config = getConfig()

export function goToEditor(appendQueryParams = true) {
  navHelper.navigateUrl(config.urls.editor, appendQueryParams ? navHelper.currentQueryParams : undefined)
}

export function goToSignUp(userService: UserService, queryParams?: QueryParams) {
  if (userService.currentUser.isAnonymous) {
    navHelper.navigateFunnelPath(config.paths.funnel.signup, queryParams)
  } else {
    goToEditor(false)
  }
}
